import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { getWhiteLabelSiteName, getWhiteLabelSiteUrl } from '../../../redux/modules/whiteLabel';
import { useAppSelector } from '@/redux/hooks';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';

const WhiteLabelCrown = () => {
    const siteName = useAppSelector(getWhiteLabelSiteName);
    const siteUrl = useAppSelector(getWhiteLabelSiteUrl);
    return (
        <StyledCrown>
            <StyledCrownInner>
                {Boolean(siteUrl) && (
                    <Link secondary to={siteUrl}>
                        <FormattedMessage id="return_to" values={{ name: siteName }} />
                    </Link>
                )}
            </StyledCrownInner>
        </StyledCrown>
    );
};

// because siteName and siteUrl will never update we can keep memo
export default React.memo(WhiteLabelCrown);

const StyledCrown = styled.div`
    background-color: ${({ theme }) => theme.colors.grey400};
    height: 34px;
    text-align: center;
    padding: 0 20px;
`;

const StyledCrownInner = styled.div`
    font-size: 12px;
    height: 14px;
    padding-top: 6px;
    max-width: 1200px;
    margin: 0 auto;
    text-align: left;

    a {
        color: ${({ theme }) => theme.colors.steel};
        &:hover {
            color: ${({ theme }) => theme.colors.black};
            text-decoration: underline;
        }
    }
`;
